import * as React from 'react';

import type { DeliverableHistoryViewModel } from 'ab-viewModels/deliverableTable.viewModel';

import * as TimeUtils from '@acceligentllc/shared/utils/time';

import type { TextColor, ColorPalette, AdditionalColors } from '@acceligentllc/shared/enums/color';

import * as ColorUtils from 'af-utils/color.util';

import Tooltip from 'af-components/Tooltip';

interface OwnProps {
	abbreviation: string;
	statusColor: ColorPalette | AdditionalColors;
	textColor: TextColor;
	history?: DeliverableHistoryViewModel[];
	onClick?: (event: React.MouseEvent) => void;
}

type Props = OwnProps;

const NUMBER_OF_ROWS = 6;

class DeliverableStatusLabel extends React.PureComponent<Props> {

	renderLabel = () => {
		const { abbreviation, statusColor, textColor, onClick } = this.props;
		const className = `deliverable-status ${ColorUtils.getColorBackgroundClass(statusColor, true)} ${ColorUtils.getColorTextClass(textColor, false, 'text-pastel-black')}`;
		return <div className={className} onClick={onClick}>{abbreviation}</div>;
	};

	renderTooltip = () => {
		const { history } = this.props;

		return (
			<>
				{(history ?? []).slice(0, NUMBER_OF_ROWS - 1).map((_history, _index) => (
					<div key={_index}><b>{TimeUtils.formatDate(_history.updatedAt)}</b>: {_history.status?.abbreviation}</div>
				))}
			</>
		);

	};

	renderLabelWithWrapper = () => {
		return <Tooltip message={this.renderTooltip()}>{this.renderLabel()}</Tooltip>;
	};

	render() {
		const { history } = this.props;
		return history?.length ? this.renderLabelWithWrapper() : this.renderLabel();
	}
}

export default DeliverableStatusLabel;
